import styled from 'styled-components/macro';

const Header = styled.header`
  margin-top: 60px;
  background-color: ${props => props.theme.colors.header};
  color: white;
  width: 100%;
  height: calc(100vh - 60px);
  //background-image: url('https://images.pexels.com/photos/5668473/pexels-photo-5668473.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260');
  background-image: url('https://images.pexels.com/photos/3771097/pexels-photo-3771097.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940');
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: top;
  //display: flex;
  //justify-content: center;
`;

export default Header